var $ = require('jquery');
require('./jquery.easing');
"use strict";

var	DEFAULTS = {
	lang: 'cs',
	messages: {
		cs: {
			close: 'Zavřít'
		},
		sk: {
			close: 'Zavrieť'
		}
	}
};

/**
 *
 * @param selector
 * @param options
 * @constructor
 */
var Curtain = function (selector, options ) {
	this.$t = $(selector);
	this.options = $.extend(true, {}, DEFAULTS, options );
	this._defaults = DEFAULTS;
	this.initialise_();
};

/**
 * Init function
 * @private
 */
Curtain.prototype.initialise_ = function() {
	this.setBasicVariables_();

	this.state = {};

	this.setInitialState();
	this.bindHandlerEvents_();

	this.$t.data('curtainInstance', this);
};

Curtain.prototype.setBasicVariables_ = function() {
	this.SELECTOR_STATIC_CONTENT = 		'.js_curtain-static-target';
	this.SELECTOR_DYNAMIC_CONTENT = 	'.js_curtain-dynamic-target';
	this.SELECTOR_HANDLER = 			'.js_curtain-handler';
	this.SELECTOR_MENU_ITEM = 			'.main-menu li a';
	this.SELECTOR_MENU_ITEM_ACTIVE = 	'.main-menu li a.active';

	this.DATA_NAME_TYPE = 				'type';
	this.DATA_NAME_DYNAMIC_CONTENT_ID = 'targetDynamicContent';

	this.EVENT_NAME_CURTAIN_CHANGED =	'CURTAIN_CURTAIN_CHANGED';
};

Curtain.prototype.setInitialState = function() {
	this.state.opened = $(this.SELECTOR_STATIC_CONTENT, this.$t).size() > 0;
	this.state.lastHandler = -1;
	this.direction = 1;

	if (this.state.opened) {
		$(this.SELECTOR_STATIC_CONTENT, this.$t).addClass('actual-curtain-content');
		if (this.$t.data('doNotInitiallyShow') != '1') {
			this.$t.show();
		}


		var menuItemActive = $(this.SELECTOR_MENU_ITEM).index($(this.SELECTOR_MENU_ITEM_ACTIVE));
		if (menuItemActive > -1) {
			this.state.lastHandler = menuItemActive;
		}
	}
};

Curtain.prototype.bindHandlerEvents_ = function() {
	var self_ = this;
	$('body').on('click', this.SELECTOR_HANDLER, function(e) {
		e.preventDefault();

		var newIndex = $(self_.SELECTOR_HANDLER).index($(e.currentTarget));
		if (newIndex == self_.state.lastHandler) {
			return false;
		} else if (newIndex < self_.state.lastHandler) {
			self_.direction = -1;
		} else {
			self_.direction = 1;
		}

		self_.state.lastHandler = newIndex;

		var type = $(e.currentTarget).data(self_.DATA_NAME_TYPE);

		// scroll up first
		$('html, body').animate({ scrollTop: 0 }, 200, function() {}).delay(200);

		/**
		 * space for more methods how to get content
		 */
		switch (type) {
			case 'dynamic-content':
				self_.loadDynamicContent_($(e.currentTarget).data(self_.DATA_NAME_DYNAMIC_CONTENT_ID), { animationType: 'horizontal', handler: $(e.currentTarget)});
				break;
			case 'dynamic-content-subtags':
				self_.loadDynamicContent_($(e.currentTarget).data(self_.DATA_NAME_DYNAMIC_CONTENT_ID), { animationType: 'vertical'});
				break;
			default:
				break;
		}

	});
};

/**
 * load content from given element, puts it into curtain-container
 * @private
 */
Curtain.prototype.loadDynamicContent_ = function(targetId, animateProperties) {
	var $target = $('#' + targetId);
	$target.appendTo(this.$t);
	this.animateCurtainContainer_($target, animateProperties);

};

Curtain.prototype.animateCurtainContainer_ = function($target, animateProperties) {
	var self_ = this;

	var positionProperties = {
		oldSlide: {},
		newSlide: {}
	};

	if (animateProperties.handler) {
		$(self_.SELECTOR_HANDLER).removeClass('active');
		$('.account a').removeClass('active');
		animateProperties.handler.addClass('active');
	}


	if (this.state.opened) {

		if (animateProperties.animationType == 'horizontal') {
			positionProperties.oldSlide = {
				from: {
					left: $('.actual-curtain-content', self_.$t).offset().left + 'px',
					top: 'auto',
					opacity: 1
				},
				to: {
					left: (-100*this.direction) + '%',
					opacity: 0
				}
			};

			positionProperties.newSlide = {
				from: {
					left: (100*this.direction)+'%',
					top: 'auto',
					opacity: 0
				},
				to: {
					left: '0%',
					opacity: 1
				}
			};
		}

		if (animateProperties.animationType == 'vertical') {
			positionProperties.oldSlide = {
				from: {
					left: $('.actual-curtain-content', self_.$t).offset().left + 'px',
					top: '10%',
					opacity: 1
				},
				to: {
					top: (-75*this.direction) + '%',
					opacity: 0
				}
			};

			positionProperties.newSlide = {
				from: {
					left: 0,
					top: (150*this.direction)+'%',
					opacity: 0
				},
				to: {
					top: '0%',
					opacity: 1
				}
			};
		}

		$('.actual-curtain-content', self_.$t).removeClass('actual-curtain-content').css(positionProperties.oldSlide.from).animate(positionProperties.oldSlide.to, 400, 'easeOutQuad');
		$target.addClass('actual-curtain-content').show().css(positionProperties.newSlide.from).animate(positionProperties.newSlide.to, 400, 'easeOutQuad', function() {
			self_.$t.trigger(self_.EVENT_NAME_CURTAIN_CHANGED, [$target]);
		});
	} else {
		$target.addClass('actual-curtain-content').css({
			left: '0%',
			top: '0%',
			opacity: 1
		}).show();
		this.$t.slideDown(function() {
			self_.state.opened = true;
			self_.$t.trigger(self_.EVENT_NAME_CURTAIN_CHANGED, [$target]);
		});
	}

	this.renderCloseButton_($target);
};

Curtain.prototype.renderCloseButton_ = function($target) {
	var self_ = this;
	$('.js_curtain-close-button', $target).remove();
	this.$closeButton = $('<a href="javascript:void(0)" class="js_curtain-close-button curtain-close-button">'+this.options.messages[this.options.lang].close+'</a>');
	this.$closeButton.on('click', function(e) {
		e.preventDefault();
		self_.closeCurtain_();
	});
	$target.append(this.$closeButton);
};


Curtain.prototype.closeCurtain_ = function() {
	var self_ = this;
	if ($(this.SELECTOR_STATIC_CONTENT, this.$t).size() > 0) {
		self_.state.opened = false;
		self_.state.lastHandler = 999;
		$('.actual-curtain-content', self_.$t).removeClass('actual-curtain-content').css({
			left: '-100%',
			opacity: 0
		});
		var handlerSelector = $(this.SELECTOR_STATIC_CONTENT, this.$t).data('curtainHandler');
		var $handler = handlerSelector ? $(handlerSelector) : null;
		this.animateCurtainContainer_($(this.SELECTOR_STATIC_CONTENT, this.$t), { animationType: 'horizontal', handler: $handler });
	} else {
		this.forceCloseCurtain();
	}
};

Curtain.prototype.forceCloseCurtain = function() {
	var self_ =  this;

	this.$t.slideUp(function() {
		self_.state.opened = false;
		self_.state.lastHandler = -1;
		$(self_.SELECTOR_HANDLER).removeClass('active');
		$('.actual-curtain-content', self_.$t).removeClass('actual-curtain-content').css({
			left: '-100%',
			opacity: 0
		});

		$(self_.SELECTOR_HANDLER).blur();
	});
};

Curtain.prototype.forceResetHandlersState = function() {
	this.state.lastHandler = -1;
};

module.exports = Curtain;





// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/Curtain.js